/**
 * Survey config — passwords and feature flags.
 * Passwords: set via REACT_APP_SURVEY_* env (e.g. in .env or deployment).
 * Do not commit real passwords; use placeholders for dev.
 */
export const surveyConfig = {
  /** Board Director survey — share link with password */
  boardDirector: {
    password: process.env.REACT_APP_SURVEY_BOARD_DIRECTOR_PASSWORD || 'oara-board-2025',
  },
  /** Board Director Follow-Up — for members exploring advisory roles */
  boardDirectorFollowup: {
    password: process.env.REACT_APP_SURVEY_BOARD_DIRECTOR_FOLLOWUP_PASSWORD || 'oara-board-2025',
  },
  /** Board Director Updated Role — Todd Embley, April 2026 governance restructure */
  boardDirectorUpdatedRole: {
    password: process.env.REACT_APP_SURVEY_BOARD_DIRECTOR_UPDATED_ROLE_PASSWORD || 'oara-board-2025',
  },
} as const;

/** SessionStorage key prefix for survey unlock (per survey slug) */
export const SURVEY_UNLOCK_KEY_PREFIX = 'survey_unlock_';
